export const globalConfig = {
  preloadStrategy: "intent",
} as const;
